<template>
  <require from="framework/value_converters/date-and-time"></require>
  <require from="framework/value_converters/escape-html"></require>
  <require from="framework/value_converters/with-links"></require>
  <require from="framework/html_behaviors/bs-tooltip"></require>
  <require from="controls/bs-form-input"></require>
  <require from="controls/as-widget-container"></require>
  <require from="controls/as-widget-list"></require>
  <require from="controls/as-form-section.html"></require>
  <require from="components/trip-details-section"></require>
  <require from="components/approval-history-table"></require>
  <require from="components/request-attachments-panel"></require>

  <div class="travel-request-form">
    <as-form-section heading="Basics">
      <div slot="body">
        <div class="form-row">
          <div class="col-md-6">
            <bs-form-input type="text" label="Trip name" placeholder="Give your business trip a unique name" value.bind="model.name & validate" disabled.bind="disabled" hasfocus.bind="autofocus" maxlength="500"></bs-form-input>
          </div>
          <div class="col-md-3" if.bind="model.createdOn">
            <bs-form-input type="text" label="Created by ${model.createdBy.name || model.createdBy.username}" value.bind="model.createdOn | dateTime" disabled="true"></bs-form-input>
          </div>
          <div class="col-md-3" if.bind="model.modifiedOn && !model.archivedOn">
            <bs-form-input type="text" label="Modified by ${model.modifiedBy.name || model.modifiedBy.username}" value.bind="model.modifiedOn | dateTime" disabled="true"></bs-form-input>
          </div>
          <div class="col-md-3" if.bind="model.archivedOn">
            <bs-form-input type="text" label="Archived by ${model.archivedBy.name || model.archivedBy.username}" value.bind="model.archivedOn | dateTime" disabled="true"></bs-form-input>
          </div>
        </div>
      </div>
    </as-form-section>
    <as-form-section heading="Travellers" intro="Please provide us with information about all bp employees and contractors who will take part in this business trip.">
      <div slot="body">
        <as-widget-list items.bind="model.travelers & validate" disabled.bind="disabled"></as-widget-list>
      </div>
      <div slot="footer" class="sc-buttons-container" show.bind="!disabled">
        <button type="button" class="btn btn-light" click.delegate="addCorporateTraveler()" disabled.bind="disabled" title="If you are an employee or contractor with a BP login enter your information here" bs-tooltip bs-tooltip.ref="corporateTravelerTooltip">
          <i class="fas fa-user-tie"></i> Add Traveller with BP login
        </button>
        <button type="button" class="btn btn-light" click.delegate="addContractorTraveler()" disabled.bind="disabled" title="If you are entering information for someone without a BP login, enter your information here, e.g. 3rd party workers, visitors and dependents" bs-tooltip bs-tooltip.ref="contractorTravelerTooltip">
          <i class="fas fa-user-ninja"></i> Add Traveller without BP login
        </button>
      </div>
    </as-form-section>
    <trip-details-section heading="Trip Itinerary" segments.bind="model.segments & validate" disabled.bind="disabled" intro="Please provide us with all the relevant information available about this trip. As a minimum, please fill-in the destination city. If you already know the itinerary, use the buttons below to add additional details."></trip-details-section>
    <as-form-section heading="Trip Details" intro="Please provide us with more information about the business purpose of this trip and your local business contacts and travel arrangements.">
      <div slot="body" class="as-widget-item si-business-details">
        <as-widget-container kind="business-details" model.bind="model.businessDetails" disabled.bind="disabled"></as-widget-container>
      </div>
    </as-form-section>
    <as-form-section heading="Countries" intro="If you do not plan to leave the airport in a transit country, please indicate this below. Then select or review approvers for each country. Travel to some countries may require approval from all assigned country approvers." if.bind="model.countryRequests.length > 0">
      <div slot="body">
        <as-widget-list items.bind="model.countryRequests" default-kind="country-request" removable.bind="false" disabled.bind="disabled"></as-widget-list>
      </div>
    </as-form-section>
    <as-form-section heading="Travel Checklist" if.bind="model.checklistItems.length > 0">
      <div slot="body">
        <div class="form-check" repeat.for="item of model.checklistItems & validate">
          <input class="form-check-input ${item.checked || !item.mandatory ? '' : 'is-invalid'}" type="checkbox" checked.bind="item.checked" disabled.bind="disabled" id="__checklist-item-${$index}">
          <label class="form-check-label" for="__checklist-item-${$index}" innerhtml="${item.message | escapeHTML | withLinks | sanitizeHTML }"></label>
        </div>
      </div>
    </as-form-section>
    <as-form-section heading="Approver's Response" if.bind="countryApprovers.length > 0 && disabled">
      <div slot="body">
        <as-widget-list items.bind="countryApprovers" default-kind="country-approver" removable.bind="false" disabled.bind="!approvingEnabled" hide-list-gutter.bind="approvingEnabled"></as-widget-list>
      </div>
    </as-form-section>
    <request-attachments-panel heading-intro="<span style='font-weight: 500;'>Restricted-level countries ONLY:</span> please provide the appropriate EVP approvals from your residing business via email attachment." controller.bind="attachmentsController" disabled.bind="disabled"></request-attachments-panel>
    <as-form-section heading="Approval History" if.bind="history != null && history.length > 0 && disabled">
      <div slot="body">
        <approval-history-table history.bind="history"></approval-history-table>
      </div>
    </as-form-section>
  </div>
</template>
